export class SourceUrlProvider {
  m3u8Url?: string;
}
